import {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {Badge, Button, Card, CardBody, CardHeader, Col, Collapse, Container, Row, Spinner,} from "reactstrap";
import {MiniGameCard} from "../../components/Custom/MiniGameCard";
import {getDb, RESPONSE_ENUM} from "../../util/Constants";
import {collection, doc, getDocs, query, where,} from "firebase/firestore";
import {getLevel} from "util/SheetManager";

export default function LevelDetails(props) {
  const [levelData, setLevelData] = useState(null);
  const [questionsData, setQuestionsData] = useState(null);
  const [miniGameData, setMiniGameData] = useState([]);
  const [loading, setLoading] = useState(null);
  const [toggled, setToggled] = useState(0);

  const history = useHistory();
  const { lName } = useParams();
  const { eventId } = useParams();

  useEffect(async () => {
    if (props.signedInUser) {
      if (props.sheetsLoaded) {
        try {
          getLevel(lName).then((_level) => {
            console.log(_level);
            setLevelData(_level);
          });
          // if (Number.isInteger(Number(lName))) {
          //   getQuestions(lName).then((_questions) =>
          //     setQuestionsData(_questions)
          //   );
          // }
        } catch (e) {
          setLevelData(null);
          // setQuestionsData(null);
        }
      }
    }
  }, [props.signedInUser, props.sheetsLoaded]);

  useEffect(async () => {
    try {
      const q = query(
        collection(getDb(), "Levels"),
        where("eventId", "==", eventId),
        where("tabName", "==", lName)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        setLevelData(doc.data());
      });
    } catch (e) {
      setLevelData(null);
    }
  }, []);

  useEffect(async () => {
    let dataArr = [];
    const parentDocumentRef = doc(getDb(), "Events", eventId);
    const subcollectionRef = collection(parentDocumentRef, lName);

    getDocs(subcollectionRef)
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          dataArr.push({ ...doc.data(), docId: doc.id });
        });
        setQuestionsData(dataArr);
      })
      .catch((error) => {
        setQuestionsData(null);
      });
  }, []);

    useEffect(async () => {
        console.log(levelData, "levelData");
    }, [levelData]);

  const deleteQuestion = async (_index) => {
    setLoading(`deleting${_index}`);
    let toDelete = null;
    const _data = questionsData.filter((_question, i) => {
      if (i === _index) {
        toDelete = _question;
        return false;
      } else {
        return true;
      }
    });

    if (toDelete) await toDelete.delete();

    setQuestionsData(_data);
    setLoading(null);
  };

  return (
    <>
      {/* <div className="header pb-8 pt-5 pt-md-8" /> */}
      <Container fluid>
        <Row className="mb-4">
          <Col
            lg={4} //{Number.isInteger(Number(lName)) ? 4 : 12}
            className="order-lg-1 mb-3 mb-lg-0"
          >
            <Card className="shadow">
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h2 className="mb-0">Details</h2>
                {/* <Button
                  color="default"
                  size="sm"
                  onClick={() =>
                    history.push(`/admin/levels/${levelData["Tab Name"]}/edit`)
                  } 
                >
                  <i className="fas fa-pencil-alt" />
                </Button> */}
              </CardHeader>
              {levelData ? (
                <CardBody>
                  <Row>
                    <Col xs={6}>
                      <p className="mb-0 small text-muted">Name</p>
                      <h2>{levelData["tabName"]}</h2>
                    </Col>
                    {/* <Col xs={6}>
                      {levelData["Final"] === "y" && (
                        <h2 className="mb-0">
                          <Badge color="primary">Final Level</Badge>
                        </h2>
                      )}
                    </Col> */}
                    <Col xs={6}>
                      <p className="mb-0 small text-muted">Passing Score</p>
                      <h2>{levelData["passingScore"]}</h2>
                    </Col>
                    <Col xs={6}>
                      <p className="mb-0 small text-muted">Time</p>
                      <h2>
                        {levelData["time"]}{" "}
                        <span className="small">seconds</span>
                      </h2>
                    </Col>
                    {Number.isInteger(Number(levelData["tabName"])) ? (
                      <>
                        <Col xs={6}>
                          <p className="mb-0 small text-muted">
                            Total Questions
                          </p>
                          <h2 className="mb-0">
                            {levelData["totalQuestion"].split("|")[0]}
                            <span className="small font-weight-light">
                              {" "}
                              questions
                            </span>
                          </h2>
                          <h2 className="mb-0">
                            {levelData["totalQuestion"].split("|")[1]}
                            <span className="small font-weight-light">
                              {" "}
                              emails
                            </span>
                          </h2>
                          <h2 className="mb-0">
                            {levelData["totalQuestion"].split("|")[2]}
                            <span className="small font-weight-light">
                              {" "}
                              sms
                            </span>
                          </h2>
                        </Col>
                        <Col xs={6}>
                          <p className="mb-0 small text-muted">Min. Attempts</p>
                          <h2 className="mb-0">
                            {levelData["minAttempt"].split("|")[0]}
                            <span className="small font-weight-light">
                              {" "}
                              questions
                            </span>
                          </h2>
                          <h2 className="mb-0">
                            {levelData["minAttempt"].split("|")[1]}
                            <span className="small font-weight-light">
                              {" "}
                              emails
                            </span>
                          </h2>
                          <h2 className="mb-0">
                            {levelData["minAttempt"].split("|")[2]}
                            <span className="small font-weight-light">
                              {" "}
                              sms
                            </span>
                          </h2>
                        </Col>
                      </>
                    ) : (
                      <Col xs={6}>
                        <p className="mb-0 small text-muted">Level</p>
                        <h2>{levelData["Total Questions"].split("=")[1]}</h2>
                      </Col>
                    )}
                    <Col xs={12} className="mt-3">
                      <p className="mb-0 small text-muted">Goal</p>
                      <p className="mb-0 text-dark">{levelData["Goal_text"]}</p>
                    </Col>
                  </Row>
                </CardBody>
              ) : (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                </div>
              )}
            </Card>
          </Col>
          {
            //normal level contains numbers mini games contains string in lname so,
            Number.isInteger(Number(lName)) ? (
              <Col lg={8} className="order-lg-0">
                <Card className="shadow mb-3">
                  <CardHeader className="border-0 d-flex justify-content-between align-items-center cardHeaderStength">
                    <h2 className="mb-0">Questions</h2>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() =>
                        history.push(
                          props.signedInUser.role === "admin"
                            ? `/admin/levels/${lName}/add-question/${eventId}`
                            : `/admin/levels/${lName}/add-question/${eventId}?superAdmin=${encodeURIComponent(
                                "gvb1hjj23n"
                              )}`
                        )
                      }
                    >
                      <i className="fas fa-plus" />
                    </Button>
                    {/* <div>      <Button color="primary" onClick={pushQuestions}>firebase push</Button>
                    </div> */}
                  </CardHeader>
                </Card>

                {questionsData ? (
                  questionsData.map((_question, _number) => (
                    <Card className="mb-1 shadow">
                      <div
                        className="d-flex justify-content-between align-items-center p-3"
                        onClick={() => setToggled(_number)}
                      >
                        <div className="d-flex justify-content-start align-items-center">
                          <p className="mb-0 small">
                            Question {_number + 1}{" "}
                            <span className="ml-2">
                              <Badge color="primary">{_question["type"]}</Badge>
                            </span>
                          </p>
                          <p className="mb-0 small ml-2">
                            <Badge color="warning">
                              {_question["ability"]}
                            </Badge>
                          </p>
                          <p className="mb-0 small ml-2">
                            {" "}
                            <Badge color="success" className="mr-2">
                              {_question["difficulty"]}
                            </Badge>
                          </p>
                        </div>
                        <div>
                          {/* <Button
                            color="danger"
                            size="sm"
                            disabled={loading && loading.startsWith("deleting")}
                            onClick={(e) => deleteQuestion(_number)}
                          >
                            {loading === `deleting${_number}` ? (
                              <Spinner color="white" size="sm" />
                            ) : (
                              <i className="far fa-trash-alt" />
                            )}
                          </Button> */}
                          <Button
                            color="default"
                            size="sm"
                            onClick={(e) =>
                              history.push(
                                props.signedInUser.role === "admin"
                                  ? `/admin/levels/${_question["docId"]}/edit-question/${_question["count"]}/${eventId}/${lName}`
                                  : `/admin/levels/${
                                      _question["docId"]
                                    }/edit-question/${
                                      _question["count"]
                                    }/${eventId}/${lName}?superAdmin=${encodeURIComponent(
                                      "gvb1hjj23n"
                                    )}`
                              )
                            }
                          >
                            <i className="fas fa-pencil-alt" />
                          </Button>
                        </div>
                      </div>

                      <Collapse isOpen={toggled === _number}>
                        <CardBody className="mt-0">
                          <hr className="mt--2" />

                          {_question["type"] !== "Question" && (
                            <Row>
                              <Col md={4} xs={6}>
                                <h6 className="mb-0">Name</h6>
                                <p>{_question["name"]}</p>
                              </Col>
                              {_question["Type"] === "Email" && (
                                <>
                                  <Col md={4} xs={6}>
                                    <h6 className="mb-0">Subject</h6>
                                    <p>{_question["subject"]}</p>
                                  </Col>
                                  <Col md={4} xs={6}>
                                    <h6 className="mb-0">Email</h6>
                                    <p>{_question["email"]}</p>
                                  </Col>
                                </>
                              )}
                            </Row>
                          )}

                          <h6 className="mb-0">Question</h6>
                          <p>{_question["question"]}</p>

                          <h6 className="mb-0">Answers</h6>
                          <ol>
                            {_question["answerOne"] && (
                              <li>
                                <p className="mb-0">{_question["answerOne"]}</p>
                                <p className="small">
                                  <Badge color="info" className="mr-2">
                                    {_question["responseOne"]}
                                  </Badge>
                                  <Badge color="success" className="mr-2">
                                    {
                                      RESPONSE_ENUM[
                                        _question["response"].split("|")[0]
                                      ]
                                    }
                                  </Badge>
                                  <Badge color="danger" className="mr-2">
                                    {_question["reward"].split("|")[0]}
                                  </Badge>
                                </p>
                              </li>
                            )}
                            {_question["answerTwo"] && (
                              <li>
                                <p className="mb-0">{_question["answerTwo"]}</p>
                                <p className="small">
                                  <Badge color="info" className="mr-2">
                                    {_question["responseTwo"]}
                                  </Badge>
                                  <Badge color="success" className="mr-2">
                                    {
                                      RESPONSE_ENUM[
                                        _question["response"].split("|")[1]
                                      ]
                                    }
                                  </Badge>
                                  <Badge color="danger" className="mr-2">
                                    {_question["reward"].split("|")[1]}
                                  </Badge>
                                </p>
                              </li>
                            )}
                            {_question["answerThree"] && (
                              <li>
                                <p className="mb-0">
                                  {_question["answerThree"]}
                                </p>
                                <p className="small">
                                  <Badge color="info" className="mr-2">
                                    {_question["responseThree"]}
                                  </Badge>
                                  <Badge color="success" className="mr-2">
                                    {
                                      RESPONSE_ENUM[
                                        _question["response"].split("|")[2]
                                      ]
                                    }
                                  </Badge>
                                  <Badge color="danger" className="mr-2">
                                    {_question["reward"].split("|")[2]}
                                  </Badge>
                                </p>
                              </li>
                            )}
                            {_question["answerFour"] && (
                              <li>
                                <p className="mb-0">
                                  {_question["answerFour"]}
                                </p>
                                <p className="small">
                                  <Badge color="info" className="mr-2">
                                    {_question["responseFour"]}
                                  </Badge>
                                  <Badge color="success" className="mr-2">
                                    {
                                      RESPONSE_ENUM[
                                        _question["response"].split("|")[3]
                                      ]
                                    }
                                  </Badge>
                                  <Badge color="danger" className="mr-2">
                                    {_question["reward"].split("|")[0]}
                                  </Badge>
                                </p>
                              </li>
                            )}
                          </ol>
                        </CardBody>
                      </Collapse>
                    </Card>
                    // <div className="mb-4">
                    //     <div className="d-flex justify-content-between align-items-center">
                    //         <p className="mb-0 small">Question {_number+1} <span className="ml-2"><Badge color="primary">{_question['Type']}</Badge></span></p>
                    //         <p className="mb-0 small"><Badge color="warning">{_question['Leadership Ability']}</Badge></p>
                    //     </div>
                    //     <hr className="my-1"/>
                    //     {
                    //         _question['Type'] !== 'Question' &&
                    //         <Row>
                    //             <Col md={4} xs={6}>
                    //                 <h6 className="mb-0">Name</h6>
                    //                 <p className="mb-1">{_question['Name']}</p>
                    //             </Col>
                    //             {
                    //                 _question['Type'] === 'Email' &&
                    //                 <>
                    //                     <Col md={4} xs={6}>
                    //                         <h6 className="mb-0">Subject</h6>
                    //                         <p className="mb-1">{_question['Subject']}</p>
                    //                     </Col>
                    //                     <Col md={4} xs={6}>
                    //                         <h6 className="mb-0">Email</h6>
                    //                         <p className="mb-1">{_question['Email']}</p>
                    //                     </Col>
                    //                 </>
                    //             }
                    //         </Row>
                    //     }
                    //     <h4 className="font-weight-normal">{_question['Question']}</h4>
                    // </div>
                  ))
                ) : (
                  <div className="text-center py-5 mt-5">
                    <Spinner color="primary" />
                  </div>
                )}
              </Col>
            ) : (
              <MiniGameCard eventId={eventId} />
            )
          }
        </Row>
      </Container>
    </>
  );
}
